import i18n from 'i18next';

import styles from '../styles/getModalLearningObjectiveSchema.module.scss';

export default () => ({
  content: {
    type: 'TextArea',
    className: styles.textArea,
    label: i18n.t('learning-objectives.modal.content-title'),
    help: i18n.t('learning-objectives.modal.content-help'),
    validators: [{ type: 'isRequired' }, { type: 'isNotEmptyString' }],
  },
});
